import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Header, Divider } from 'semantic-ui-react';
import { Wrappers } from '../components';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { compose } from 'react-apollo';
import { withAuth, AuthStates } from '../auth';

const agiEmail = 'agidealersupport@aggrowth.com';

const ContactUs = ({ authState, analytics }) => {
  const handleEmailClick = () => {
    analytics.trackEvent('Email AGI Rep', {
      isLoggedIn: (authState === AuthStates.SignedIn).toString(),
      'Generic Email Sent Page': 'Contact Us Page'
    });
  };

  return (
    <Wrappers.Layout menu>
      <Wrappers.SegmentFull>
        <Header as="h1" data-qa="h1-contact-us">
          <FormattedMessage
            id="title.contact"
            description="Contact Us page title"
            defaultMessage="Contact Us"
          />
        </Header>
        <FormattedMessage
          id="subtitle.contact"
          defaultMessage="You can reach us via email at"
        />
        <br />
        <span onClick={handleEmailClick}>
          <a
            rel="noopener noreferrer"
            data-qa="email-us"
            href={`mailto:${agiEmail}`}
            target="_blank"
          >
            {agiEmail}
          </a>
        </span>
        <Divider hidden />
        <p>
          <FormattedMessage
            id="description.contact"
            defaultMessage="We’re committed to service! We will respond to your email within 3 business days."
          />
        </p>
      </Wrappers.SegmentFull>
    </Wrappers.Layout>
  );
};

ContactUs.propTypes = {
  intl: intlShape.isRequired,
  analytics: PropTypes.object.isRequired,
  authState: PropTypes.string
};

export default compose(
  withAuth,
  injectIntl,
  withAnalytics,
  withPageViewTracking()
)(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs.js